import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage, injectIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import { SimpleLink } from '../partials/Navigation/Buttons'
import withAppStore from '../../util/withAppStore'
import styles from '../../../css/home.module.css'

function UserPage (props) {
  const navigate = useNavigate()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo('/home')
  }, [goTo])

  let accountType = 'Unknown'
  let preferenceTemperature = 'Unknown'
  let preferenceLanguage = 'Unknown'
  let preferenceUnitsVolume = 'Unknown'
  let preferenceUnitsFlow = 'Unknown'
  const {
    intl: {
      formatMessage,
    },
    route: {
      path: page,
    },
  } = props
  if (
    typeof props.data.user.data.permissions === 'object' &&
    typeof props.data.user.data.locale === 'object'
  ) {
    if (props.data.user.data.permissions.level < 10) {
      accountType = formatMessage({
        id: 'invite.accountType.viewer',
        defaultMessage: 'Viewer',
        description: '',
      })
    } else if (props.data.user.data.permissions.level < 20) {
      accountType = formatMessage({
        id: 'invite.accountType.manager',
        defaultMessage: 'Manager',
        description: '',
      })
    } else if (props.data.user.data.permissions.level < 30) {
      accountType = formatMessage({
        id: 'invite.accountType.admin',
        defaultMessage: 'Administrator',
        description: '',
      })
    } else if (props.data.user.data.permissions.level < 40) {
      accountType = formatMessage({
        id: 'invite.accountType.distributor',
        defaultMessage: 'Distributor',
        description: 'distributor account type label',
      })
    }

    let {
      data: {
        user: {
          data: {
            locale: {
              language,
              tempConv = 'f',
              unitsOfVolume,
              unitsOfFlow,
            } = {},
          },
        },
      },
    } = props

    if (tempConv === 'f') {
      preferenceTemperature = formatMessage({
        id: 'profile.temperatureScale.f',
        defaultMessage: 'Fahrenheit (F)',
        description: '',
      })
    } else if (tempConv === 'c') {
      preferenceTemperature = formatMessage({
        id: 'profile.temperatureScale.c',
        defaultMessage: 'Celsius (C)',
        description: '',
      })
    }

    if (unitsOfVolume === 'acreInch') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.acreInch',
        defaultMessage: 'Acre-Inch (ac-in)',
        description: '',
      })
    } else if (unitsOfVolume === 'gallons') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.gallons',
        defaultMessage: 'Gallons (gal)',
        description: '',
      })
    } else if (unitsOfVolume === 'cubicFeet') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.cubicFeet',
        defaultMessage: 'Cubic-Feet (ft³)',
        description: '',
      })
    } else if (unitsOfVolume === 'hectareM') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.hectareM',
        defaultMessage: 'Hectare-M (ha-m)',
        description: '',
      })
    } else if (unitsOfVolume === 'liters') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.liters',
        defaultMessage: 'Liters (l)',
        description: '',
      })
    } else if (unitsOfVolume === 'cubicM') {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.cubicM',
        defaultMessage: 'Cubic Meters (m³)',
        description: '',
      })
    } else {
      preferenceUnitsVolume = formatMessage({
        id: 'profile.unitsOfVolume.acreFeet',
        defaultMessage: 'Acre-Feet (ac-ft)',
        description: '',
      })
    }

    if (unitsOfFlow === 'lpm') {
      preferenceUnitsFlow = formatMessage({
        id: 'profile.unitsOfFlow.lpm',
        defaultMessage: 'Liters Per Minute (lpm)',
        description: '',
      })
    } else {
      preferenceUnitsFlow = formatMessage({
        id: 'profile.unitsOfFlow.gpm',
        defaultMessage: 'Gallons Per Minute (gpm)',
        description: '',
      })
    }

    if (language !== 'es' && language !== 'en' && language !== 'fr') {
      if (
        'language' in navigator &&
        (navigator.language).substring(0, 2) === 'es'
      ) {
        language = 'es'
      } else {
        language = 'en'
      }
    }
    if (language === 'es') {
      preferenceLanguage = formatMessage({
        id: 'profile.language.spanish',
        defaultMessage: 'Español',
        description: '',
      })
    } else if (language === 'en') {
      preferenceLanguage = formatMessage({
        id: 'profile.language.english',
        defaultMessage: 'English',
        description: '',
      })
    } else if (language === 'fr') {
      preferenceLanguage = formatMessage({
        id: 'profile.language.french',
        defaultMessage: 'Français',
        description: '',
      })
    }
  }
  const PROFILE = formatMessage({
    id: 'navigation.profile',
    defaultMessage: 'Profile',
    description: '',
  })

  return (
    <div>
      <Helmet><title>{props.pages.UserPage}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        name={PROFILE}
        page={page}
        logOut={() => props.auth.logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <section className={styles.userSection} name='profileInfo'>
              <h2 className={styles.userSectionTitle}>
                <FormattedMessage
                  id='profile.info'
                  defaultMessage='Info'
                  description='Profile Info label'
                />
              </h2>
              <FormattedMessage
                id='profile.username'
                defaultMessage='Username'
                description='Username label'
              >
                {(txt) => (
                  <SimpleLink
                    path=''
                    label={txt}
                    value={props.data.user.data.email || 'Not Available'}
                    unit=''
                  />
                )}
              </FormattedMessage>
              <FormattedMessage
                id='profile.accountType'
                defaultMessage='Account Type'
                description='Account Type label'
              >
                {(txt) => (
                  <SimpleLink
                    path=''
                    label={txt}
                    value={accountType}
                    unit=''
                  />
                )}
              </FormattedMessage>
            </section>
            <br />
            <section className={styles.userSection} name='profilePreferences'>
              <h2 className={styles.userSectionTitle}>
                <FormattedMessage
                  id='profile.preferences'
                  defaultMessage='Preferences'
                  description='Profile Preferences label'
                />
              </h2>
              <SimpleLink
                path='/user/preferences/pin'
                label={formatMessage({
                  id: 'pinCode.preferences',
                  defaultMessage: 'Pin Code',
                  description: '',
                })}
                value={formatMessage({
                  id: 'profile.change',
                  defaultMessage: 'Change',
                  description: '',
                })}
                unit=''
                enable
              />
              <FormattedMessage
                id='profile.temperatureScale.name'
                defaultMessage='Temperature Scale'
                description='Temperature Scale label'
              >
                {(txt) => (
                  <SimpleLink
                    path='/user/preferences/temperature'
                    label={txt}
                    value={preferenceTemperature}
                    unit=''
                    enable
                  />
                )}
              </FormattedMessage>
              <FormattedMessage
                id='profile.unitsOfVolume.name'
                defaultMessage='Units of Volume'
                description='Units of Volume label'
              >
                {(txt) => (
                  <SimpleLink
                    path='/user/preferences/unitsOfVolume'
                    label={txt}
                    value={preferenceUnitsVolume}
                    unit=''
                    enable
                  />
                )}
              </FormattedMessage>
              <FormattedMessage
                id='profile.unitsOfFlow.name'
                defaultMessage='Units of Flow'
                description='Units of Flow label'
              >
                {(txt) => (
                  <SimpleLink
                    path='/user/preferences/unitsOfFlow'
                    label={txt}
                    value={preferenceUnitsFlow}
                    unit=''
                    enable
                  />
                )}
              </FormattedMessage>
              <FormattedMessage
                id='profile.language.name'
                defaultMessage='Language'
                description='Language label'
              >
                {(txt) => (
                  <SimpleLink
                    path='/user/preferences/language'
                    label={txt}
                    value={preferenceLanguage}
                    unit=''
                    enable
                  />
                )}
              </FormattedMessage>
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

UserPage.propTypes = {
  pages: PropTypes.object,
  data: PropTypes.object,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  auth: PropTypes.object,
}

export default withAppStore(injectIntl(UserPage))
